import { render } from "./Vehicle.vue?vue&type=template&id=3aed4312&scoped=true"
import script from "./Vehicle.vue?vue&type=script&lang=js"
export * from "./Vehicle.vue?vue&type=script&lang=js"

import "./Vehicle.vue?vue&type=style&index=0&id=3aed4312&scoped=true&lang=scss"
script.render = render
script.__scopeId = "data-v-3aed4312"

export default script